import React, { useState, useEffect, useMemo } from "react";
import CheckAuth from "../../authentication/common/hooks/CheckAuth";
import { Pagination, Card, Col, Row, Avatar, Empty, Space, Tooltip, Badge } from 'antd';
import "../../../styles/HomeTabSwitchingStyle.css";
import axios from "axios";
import EmployeeListingLoaderLayout from "../../screenLoader/EmployeeListingLoaderLayout"
import Search from "antd/es/input/Search";
import CardComponent from "./CardComponent";
import Constants from "../../../utils/Constants";


export default function ExpiredEmployeeLayout() {
  CheckAuth();

  const RECORD_SIZE = 8;
  const USER_TYPE = 'no';
  const API_BASE_URL = Constants.API_BASE_URL;

  const [employeeInformation, setEmployeeInformation] = useState(
      []
  );
  const [totalNumberOfUsers, setTotalNumberOfUsers] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  const [loggedInUserEmployeeID, setLoggedInUserEmployeeID] = useState("");

  const [loading, setLoading] = useState(false)
  const searchInputTooltipText = "Search by Name, Employee-Id, Gender, Type, Department or Designation"
  const [arrow, setArrow] = useState('Show');
  const mergedArrow = useMemo(() => {
    if (arrow === 'Hide') {
      return false;
    }
    if (arrow === 'Show') {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);
  const fetchData = async () => {
    try {
      setLoading(true);
      const accessToken = sessionStorage.getItem("accessToken");
      const response = await axios.get(
          `${API_BASE_URL}/api/v1/client/search/employees`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
            params: {
              searchQuery,
              page: currentPage,
              limit: RECORD_SIZE,
              active: USER_TYPE
            },
          }
      );
      const { data } = response;

      setEmployeeInformation(
          data.data.employeesList
      );
      setTotalNumberOfUsers(
          data.data.totalEmployee
      );
      setLoading(false);
    } catch (error) {
      console.error(
          "Error fetching search results on active employees :",
          error
      );
    }
  };
  useEffect(() => {
    fetchData().then(()=>{
      window.scrollTo(0, 0);
    });
  }, [searchQuery, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleSearch = (event) => {
    const value = event;
    setSearchQuery(value)
    setCurrentPage(1);
  }

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Space direction="vertical" >
          <Tooltip
            placement="top"
            title={searchInputTooltipText}
            color="#2db7f5"
            arrow={mergedArrow}
            mouseLeaveDelay={0.7}
            overlayStyle={{
              fontSize: "12px",
              maxWidth: "250px",
              height: "50px",
            }}

          >
            <Search
              placeholder="Type Name, EmployeeId, Gender, Type Department or Designation..."
              allowClear
              onSearch={handleSearch}
              style={{
                width: 235,
                marginBottom: '10px',
                fontSize: "9px"
              }}
            // className="employee-search-text"

            />
          </Tooltip>
        </Space>
      </div>

      {loading ? (
        <EmployeeListingLoaderLayout screenLoaderText="Loading Data..." />
      ) : (
        <>
          {searchQuery ? (
            <>
              {totalNumberOfUsers === 0 ? (
                <div style={{ textAlign: "center", marginTop: "140px" }}>
                  <Empty
                    image={Empty.PRESENTED_IMAGE_DEFAULT}
                    description={<p style={{ color: "#ababab" }}>No Expired Employees Found!</p>}
                  />
                </div>
              ) : (
                <div className="site-card-wrapper">
                  <Row gutter={[16, 16]}>
                    {employeeInformation.map((employee, index) => (
                      <Col xs={24} md={12} xl={6} key={index}>
                        {employee.employee_id === loggedInUserEmployeeID ? (
                          <Badge.Ribbon text="My Profile" size="small" color="rgb(0,176,240)">
                            <CardComponent employee={employee} />
                          </Badge.Ribbon>
                        ) : (<CardComponent employee={employee} />)}
                      </Col>
                    ))}
                  </Row>
                </div>
              )}
              <div style={{ margin: "18px", display: "flex", justifyContent: "center" }}>
                <Pagination
                  current={currentPage}
                  total={totalNumberOfUsers}
                  pageSize={RECORD_SIZE}
                  onChange={handlePageChange}
                />
              </div>
            </>
          ) : (
            <>
              {totalNumberOfUsers === 0 ? (
                <div style={{ textAlign: "center", marginTop: "140px" }}>
                  <Empty
                    image={Empty.PRESENTED_IMAGE_DEFAULT}
                    description={<p style={{ color: "#ababab" }}>No Expired Employees Found!</p>}
                  />
                </div>
              ) : (
                <div className="site-card-wrapper">
                  <Row gutter={[16, 16]}>
                    {employeeInformation.map((employee, index) => (
                      <Col xs={24} md={12} xl={6} key={index}>
                        {employee.employee_id === loggedInUserEmployeeID ? (
                          <Badge.Ribbon text="My Profile" size="small" color="rgb(0,176,240)">
                            <CardComponent employee={employee} />
                          </Badge.Ribbon>
                        ) : (
                            <CardComponent employee={employee} />
                        )}
                      </Col>
                    ))}
                  </Row>
                </div>
              )}
              <div style={{ margin: "18px", display: "flex", justifyContent: "center" }}>
                <Pagination
                  defaultCurrent={currentPage}
                  total={totalNumberOfUsers}
                  pageSize={RECORD_SIZE}
                  onChange={handlePageChange}
                />
              </div>
            </>
          )}
        </>
      )}
    </>
  );
}